import * as React from "react";

import { cn } from "../../utils";

export type ActionBarProps = React.HTMLAttributes<HTMLDivElement>;

function ActionBar({ className, children, ...props }: ActionBarProps) {
  return (
    <div
      className={cn(
        "af-rounded-lg af-border af-border-interface-border af-bg-card af-p-3 af-font-medium af-text-muted-foreground af-shadow-2xl",
        className,
      )}
      {...props}
    >
      <div className="af-flex af-h-9 af-items-center af-justify-between af-gap-4 af-text-sm">
        {children}
      </div>
    </div>
  );
}
ActionBar.displayName = "ActionBar";

function ActionBarGroup({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("af-flex af-items-center af-gap-2", className)}
      {...props}
    />
  );
}
ActionBarGroup.displayName = "ActionBarGroup";

export { ActionBar, ActionBarGroup };
